import { FC } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
  Button,
} from "../ui";
import { ArrowLeft } from "lucide-react";
import { BreadcrumbDataType, HeadingProps } from "./types";

const Heading: FC<HeadingProps> = ({
  title,
  showBack,
  onBackClick,
  breadcrumbData,
}) => {
  return (
    <div className="flex flex-col gap-1">
      {showBack && (
        <Button
          variant="ghost"
          className="flex flex-row text-[13px] items-center justify-start w-[70px] !p-0"
          onClick={onBackClick}
        >
          <ArrowLeft className="h-4 w-4" /> Back
        </Button>
      )}
      <h2 className="text-[18px] leading-[19px] md:text-[22px] md:leading-[24px] font-normal items-start flex text-black-400">
        {title}
      </h2>
      {breadcrumbData?.length && (
        <Breadcrumb>
          <BreadcrumbList className="text-[12px] lg:w-[500px] text-wrap !gap-1">
            {breadcrumbData.map((data: BreadcrumbDataType, index: number) => (
              <>
                <BreadcrumbItem>
                  {data.link ? (
                    <BreadcrumbLink
                      href={data.link}
                      className={
                        index == breadcrumbData.length - 1 ? "text-primary" : ""
                      }
                    >
                      {data.name}
                    </BreadcrumbLink>
                  ) : (
                    <span
                      className={
                        index == breadcrumbData.length - 1 ? "text-primary" : ""
                      }
                    >
                      {data.name}
                    </span>
                  )}
                </BreadcrumbItem>
                {index != breadcrumbData.length - 1 && (
                  <BreadcrumbSeparator>/</BreadcrumbSeparator>
                )}
              </>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      )}
    </div>
  );
};

export default Heading;
